"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propertyEditorInternalContext = _interopRequireDefault(require("./../contexts/property-editor-internal-context"));

function withRegisterFieldId(WrappedComponent) {
  var RegisterFieldId = function RegisterFieldId(props) {
    var _useContext = (0, _react.useContext)(_propertyEditorInternalContext["default"]),
        containsRestFields = _useContext.containsRestFields,
        unRegisterFieldId = _useContext.unRegisterFieldId,
        registerFieldId = _useContext.registerFieldId;

    (0, _react.useEffect)(function () {
      if (props.doNotRegisterMe !== true) {
        registerFieldId(props.fieldId);
      }

      return function () {
        !containsRestFields && unRegisterFieldId(props.fieldId);
      };
    }, [props.fieldId, props.doNotRegisterMe, registerFieldId, containsRestFields, unRegisterFieldId]);
    return /*#__PURE__*/_react["default"].createElement(WrappedComponent, props);
  };

  RegisterFieldId.propTypes = {
    doNotRegisterMe: _propTypes["default"].bool,
    fieldId: _propTypes["default"].string
  };
  return RegisterFieldId;
}

var _default = withRegisterFieldId;
exports["default"] = _default;